module.exports = __webpack_public_path__ + "img/chess-pawn-piece.2cea6cb5.svg";